module.exports = __webpack_public_path__ + "media/images/themes/autumn_ice_queen/main_bg-d7d2c5d8e16794602d29b8eeff9d1d9d.png";